import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";
import { AuthProvider } from "@/lib/auth";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AnalyticsTracker } from "@/components/Analytics";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Areas from "@/pages/Areas";
import OwnerFAQ from "@/pages/OwnerFAQ";
import ResidentFAQ from "@/pages/ResidentFAQ";
import Contact from "@/pages/Contact";
import RentalAnalysis from "@/pages/RentalAnalysis";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";

function MarketingSite() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/areas" element={<Areas />} />
        <Route path="/owner-faq" element={<OwnerFAQ />} />
        <Route path="/resident-faq" element={<ResidentFAQ />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/rental-analysis" element={<RentalAnalysis />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AnalyticsTracker />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            <Route path="/*" element={<MarketingSite />} />
          </Routes>
          <Toaster position="bottom-right" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
